import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export const ApiRequests = {
  homePage: `:backend-url/home/:fr-loc`,
  byUrl: `:backend-url/:fr-loc`,
  listFolders: `:backend-url/content/list/:fr-loc/folders`,
  footer: `:backend-url/content/footer/:fr-loc`,
  franchise: `:backend-url/franchises`,
  related: `:backend-url/content/:id/related/:fr-loc`,
  tagRelated: `:backend-url/content/:id/tag-related/:fr-loc`,
  getAvailableCommunications: `:backend-url/users/profile/my/communications/available`,
  getCommunications: `:backend-url/users/profile/my/communications/get`,
  saveCommunications: `:backend-url/users/profile/my/communications/save`,
  getContinentItems: `:backend-url/content/list/:fr-loc/jurisdictions`,
  getFolderCollection: `:backend-url/folders/:id/collections`,
  getMySettings: `:backend-url/users/profile/my/settings/get`,
  saveMySettings: `:backend-url/users/profile/my/settings/save`,

  getTopicsContentTypes: `:backend-url/content/my-topics/content-types`,
  getTopicsItems: `:backend-url/content/my-topics/:content-type/items`,
  markAllTopicsRead: `:backend-url/content/my-topics/:content-type/mark-read`,

};

@Injectable({
  providedIn: 'root',
})
export class ApiConfig {
  config: any;
  url: string = '';

  constructor(private http: HttpClient) {}

  // Get config from file during runtime & set url and franchise
  public initAppConfig(): Observable<any> {
    return this.http.get('./assets/configs/config.json').pipe(tap(data => {
      this.config = data;
      this.url = this.config.backend.url;
    }));
  }

}
